import * as urlencode from 'urlencode';
import { FORMATTERS } from '@/config';

export const compartir = async function(url, text, title, fileConfig) {
	let shareData = {
		'url': url,
		'text': text,
		'title': title,
	};
	
	if( !!fileConfig ){
		const {
			url, fileName, rut, razonSocial
		} = fileConfig;
		let blob = await fetch(url).then(r => r.blob());
		const files = [
			new File([blob], fileName, {
			  type: 'application/pdf',
			}),
		]
		shareData.files = files
		shareData.text = mensajeCompartir
				.replace(':RUT', rut)
				.replace(':RAZON_SOCIAL', razonSocial)
				
		if (window.navigator.canShare(shareData)) {
			
			delete shareData.url
			await window.navigator.share(shareData);
		}else{
			delete shareData.files
		}
	}
	
	// Estándar indica que share solo funciona bajo https
	window.navigator.share(shareData);
};

export const puedeCompartir = function() {
	// A futuro reemplazar por window.navigator.canShare, que al momento (13-jul-2020) 
	// no está ampliamente implementado en los navegadores.
	let puede = (window.navigator.share !== undefined);
	return puede;
};

export const mensajeCompartir = `El contribuyente RUT :RUT :RAZON_SOCIAL ha compartido con usted este documento generado a través de eBoleta - SII.
Gracias por su preferencia.`;

export const subjectCompartir = `eBoleta - Folio :FOLIO - Monto :MONTO`;

export function getMensajeCompartir(rutDV, razonSocial, url=false){
	let out = mensajeCompartir
		.replace(':RUT', rutDV)
		.replace(':RAZON_SOCIAL', razonSocial);
	if(url){
		out = `${out}\n\n${url}`
	}
	return urlencode(out);
}

export function getSubjectCompartir(folio, monto){

	return subjectCompartir
		.replace(':FOLIO', folio)
		.replace(':MONTO', FORMATTERS.MONEY(monto||0) );
}